import type { ContractPrintSettings } from '../contract/types';
import { renderHtmlOffscreen } from '../utils/renderOffscreen';
import { buildPdfBlob } from './pdfExporter';

export type AttachmentFormat = 'pdf' | 'xlsx';

export async function buildAttachmentFile(input: {
  html: string;
  settings: ContractPrintSettings;
  name: string;
  format: AttachmentFormat;
}): Promise<File> {
  const { settings: s } = input;
  const paper = { A4: [210, 297], A5: [148, 210], A3: [297, 420], Letter: [216, 279] }[s.paperSize];
  const rendered = await renderHtmlOffscreen(input.html, paper[s.orientation === 'portrait' ? 0 : 1]);
  try {
    const name = input.name.replace(/\.(?:pdf|xlsx)$/i, '').replace(/[\\/:*?"<>|]/g, '_') || '单据';
    const blob = input.format === 'xlsx'
      ? await (await import('./excelExporter')).buildExcelBlob({ source: rendered.body, settings: s, name })
      : await buildPdfBlob({ source: rendered.body, ...s, fileName: 'x.pdf', continuous: !!s.continuousPage });
    return new File([blob], `${name}.${input.format}`, { type: blob.type });
  } finally { rendered.cleanup(); }
}
